import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/core/auth/AuthContext';
import { ratesService } from '../services/rates.service';
import type { RateCreatePayload, RateUpdatePayload } from '../types/rates.types';
import { toast } from 'sonner';

export function useRates() {
  const { profile } = useAuth();
  const companyId = profile?.company_id || '';
  const userId = profile?.id || '';
  const queryClient = useQueryClient();

  const queryKey = ['inventory', 'rates'];

  const query = useQuery({
    queryKey,
    queryFn: () => ratesService.fetchRates(),
  });

  const createMutation = useMutation({
    mutationFn: (payload: RateCreatePayload) => ratesService.createRate(userId, companyId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
      toast.success('Thêm đơn giá thành công');
    },
    onError: (err: any) => {
      console.error(err);
      toast.error(err.message || 'Lỗi khi thêm đơn giá');
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: RateUpdatePayload }) => 
      ratesService.updateRate(userId, companyId, id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
      toast.success('Cập nhật đơn giá thành công');
    },
    onError: (err: any) => {
      console.error(err);
      toast.error(err.message || 'Lỗi khi cập nhật đơn giá');
    },
  });

  const deleteMutation = useMutation({
    mutationFn: (id: string) => ratesService.deleteRate(userId, companyId, id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
      toast.success('Xóa đơn giá thành công');
    },
    onError: (err: any) => {
      console.error(err);
      toast.error(err.message || 'Lỗi khi xóa đơn giá');
    },
  });

  return {
    data: query.data || [],
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    createRate: createMutation.mutateAsync,
    isCreating: createMutation.isPending,
    updateRate: updateMutation.mutateAsync,
    isUpdating: updateMutation.isPending,
    deleteRate: deleteMutation.mutateAsync,
    isDeleting: deleteMutation.isPending,
  };
}
